import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69e8525663911b00144a21a8/businesssite_1776833110345/src/app/culture/page.tsx");
